import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";

// Import components for routes
import Root from "./components/Root";
import ErrorPage from "./components/ErrorPage";
import PrivacyPolicy from "./components/delight/PrivacyPolicy";
import LandingPage from "./components/delight/LandingPage";
import Login from "./components/Login";
import { useAuth } from "./components/features/AuthContext";
import React from 'react';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, login } = useAuth();
  if (!isAuthenticated) {
    return <Login onLogin={(email) => login(email)} />;
  }
  return <>{children}</>;
};

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginWrapper />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Root />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
    ],
  },
]);

function LoginWrapper() {
    const { login } = useAuth();
    return <Login onLogin={(email) => {
        login(email);
        window.location.href = "/";
    }} />;
}


// App component renders RouterProvider with defined router
const App = () => (
  <RouterProvider router={router} />
);

export default App;
